import { Component, OnInit } from '@angular/core';
import { GeneralComponent } from '../../General/g.component';
import { TopicService } from '../topic.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';

@Component({
  selector: 'app-t-all-exercises',
  templateUrl: './t-all-exercises.component.html',
  styleUrls: ['../../General/tiles.css', './t-all-exercises.component.css']
})
export class TAllExercisesComponent extends GeneralComponent {

  allExercises: any[] = [];
  allExams: any[] = [];
  isExam: boolean = false;
  examId: number = undefined;
  title = "";

  movingExercises: any[] = [];

  constructor(protected topicService: TopicService, protected activatedRoute: ActivatedRoute, private messageService: MessageService) {
    super(topicService);
    this.allExercises = topicService.getAllExercises().map(exercise => ({ ...exercise }));
    if (this.activatedRoute.snapshot.paramMap.has('examid')) {
      this.examId = +this.activatedRoute.snapshot.paramMap.get('examid');
      this.title = this.topicService.getExamById(this.examId).title;
      this.allExercises = topicService.getAllQuestionsById(this.examId).map(exercise => ({ ...exercise }));
      this.isExam = true;
    } else {
      this.allExams = topicService.getAllExams();
    }

  }

  /** saves the changes made in order */
  saveChanges() {
    let index = 1;
    for (let exercise of this.allExercises) {
      exercise.id = index;
      index++;
    }
    if (!this.isExam) {
      this.topicService.updateAllExercises(this.allExercises);

      for (let moving of this.movingExercises) {
        this.topicService.addQuestion(moving.examId, moving.exercise)
      }
    } else {
      this.topicService.updateAllQuestions(this.allExercises, this.examId);

      for (let moving of this.movingExercises) {
        this.topicService.addExercise(moving.exercise)
      }
    }
    this.messageService.addAlertWithTimeout(this.get("saveDone"), "success", 5000);
  }

  /** deletes the exercise from the exercise list. Does NOT save 
   * @param {number} index - index of exercise to delete
  */
  deleteExercise(index: number): void {
    this.allExercises.splice(index, 1)
  }

  get_title() {
    return this.title;
  }

  /** add the exercise in event to the exercise set with examId */
  dragToSerie(examId: number, event: any) {
    let index = this.allExercises.map((v, i) => [i, v.id]).filter(v => v[1] == event.dragData).map(v => +v[0])[0];
    let exercise = this.allExercises[index];
    let maxId = this.topicService.getMaxId(examId);
    exercise.id = maxId + 1;
    this.movingExercises.push({
      examId: examId,
      exercise: exercise
    });
    this.allExercises.splice(index, 1);
  }

  /** add the exercise in event to the general exercises */
  dragToExercises(event: any) {
    let index = this.allExercises.map((v, i) => [i, v.id]).filter(v => v[1] == event.dragData).map(v => +v[0])[0];
    let exercise = this.allExercises[index];
    let maxId = this.topicService.getMaxId();
    exercise.id = maxId + 1;
    this.movingExercises.push({
      exercise: exercise
    });
    this.allExercises.splice(index, 1);
  }

}
